"use client";

import en from "@/dictionaries/en";
import tw from "@/dictionaries/tw";
import { useLocale } from "@/lib/useLocale";

const dictionaries = {
  tw,
  en,
} as const;

export function useDictionary() {
  const locale = useLocale();
  return dictionaries[locale];
}
